export const triggerClassName = (
  param1: string,
  param2: string,
  className: string,
): string => (param1 === param2 ? className : '')

export const getClassNameByParam = (
  param: boolean,
  className: string,
): string => (param ? className : '')

// Dependency-free className composer (clsx-style) for CSS Modules conditional/multi-class usage.
// Filters out falsy parts and space-joins the rest: cx(styles.a, cond && styles.b, props.className)
export const cx = (
  ...parts: Array<string | false | null | undefined>
): string => parts.filter(Boolean).join(' ')

export const classNameUtil = {
  triggerClassName,
  getClassNameByParam,
  cx,
} as const
